import React, { useState } from "react";
import { Link } from "react-router-dom";
import { usePagination } from "../hooks/usePagination";
import { useMemo } from "react";

const Pagination = ({
  totalPages,
  show = false,
  offset = 5,
  handlePageSelect,
}) => {
  const { page: currentPage } = usePagination();

  const totalSheets = Math.ceil(totalPages / offset);
  const [currentSheet, setCurrentSheet] = useState(0);

  const start = offset * currentSheet + 1;

  const pageRange = useMemo(() => {
    if (currentSheet + 1 === totalSheets) {
      return [
        ...Array(offset - ((currentSheet + 1) * offset - totalPages)).fill(0),
      ];
    }

    return [...Array(offset).fill(0)];
  });

  const handlePrev = () => {
    if (currentSheet > 0) setCurrentSheet(currentSheet - 1);
  };
  const handleNext = () => {
    if (currentSheet + 1 < totalSheets) setCurrentSheet(currentSheet + 1);
  };

  return (
    <>
      {show ? (
        <>
          <div className="d-flex align-items-center">
            <p className="text-primary">{`Showing Pages - ${
              currentPage + 1
            } / ${totalPages}`}</p>
            <nav>
              <ul className="pagination ms-4">
                <>
                  <PageItem
                    key={`page-item-prev`}
                    active={currentPage > 0}
                    disabled={currentPage < 0}
                    text={"<"}
                    page={currentPage - 1 < 0 ? currentPage : currentPage - 1}
                  />

                  {currentSheet > 0 && (
                    <PageItem
                      key={`show-less-pages`}
                      onClick={handlePrev}
                      disabled={currentPage < 0}
                      text={"..."}
                      page={currentPage}
                    />
                  )}

                  {/* Page Items */}
                  {pageRange.map((page, index) => (
                    <PageItem
                      page={start + index - 1}
                      active={start + index === currentPage + 1}
                      text={start + index}
                      disabled={!totalPages || 0}
                      onClick={() => handlePageSelect(start + index - 1)}
                    />
                  ))}

                  {currentSheet < totalSheets - 1 && (
                    <PageItem
                      key={`show-more-pages`}
                      disabled={currentPage >= totalPages - 1}
                      text={"..."}
                      page={currentPage}
                      onClick={handleNext}
                    />
                  )}

                  <PageItem
                    key={`page-item-next`}
                    active={currentPage < totalPages}
                    disabled={currentPage >= totalPages - 1}
                    text={">"}
                    page={
                      currentPage + 1 >= totalPages
                        ? currentPage
                        : currentPage + 1
                    }
                  />
                </>
              </ul>
            </nav>
          </div>
        </>
      ) : null}
    </>
  );
};

export const PageItem = ({ page, active, text, disabled, ...props }) => {
  return (
    <>
      <li
        className={`page-item ${active && "active"} ${disabled && "disabled"}`}
        {...props}
      >
        <Link className="page-link" to={`?page=${page}`}>
          {text || 1}
        </Link>
      </li>
    </>
  );
};

export default Pagination;
